import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import EjectIcon from "./img/eject-icon.svg"
import SettingsIcon from "./img/settings-icon.svg"
import GlossaryIcon from "./img/glossary-icon.svg"

import "./style.scss";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";

import { GlossaryProvider } from '@learningblocks/storybook-components';


function GlossaryButton(props) {

  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  const showThermocyclerGlossary = () => {
    onOpenGlossary('recJhFCa57wsxAAaV')
  };

  return (
    <button
      ariaLabel={"Open thermocycler definition."}
      onClick={()=>showThermocyclerGlossary("recJhFCa57wsxAAaV")}
    >
      <img alt="" src={GlossaryIcon}/>
    </button>
  )
}

export class Thermocycler extends React.Component {


  componentWillMount() {
    this.props.createThermocycler({
      props: this.props.defaultProps,
    });
  }

  showControls = () => {
    this.props.hideAllControls();
    this.props.setThermocyclerControlVisibility({id: this.props.id, controlsVisible: true});
  }

  showThermocyclerControls = () => {
    this.props.setModal({
      type: 'THERMOCYCLER_CONTROLS',
      size: 'inside',
      connect: this.props.id
    });

    this.props.showModal({ display: true});
  };

  ejectAllSolutions = () => {

    this.props.solutions.forEach((solution)=>{
      this.props.setSolutionInScene({
        id: solution.id,
        inScene: true
      })
    })
    this.props.removeAllTubesFromThermocycler({
      id: this.props.id
    })
  }

  getControls = () => {
    return (
      <div className={"Controls"} style={{
        display: "flex",
        height: "50px",
        flexDirection: "row",
        background: "white",
        borderRadius: "5px",
        border: "1px solid "+colors.navy1
      }}>
        <GlossaryButton />
        <button
          aria-label={"Open thermocycler controls."}
          onClick={this.showThermocyclerControls}
        >
          <img alt="" src={SettingsIcon}/>
        </button>
        <button
          aria-label={((!this.props.open)?"Open":"Close") + " " + this.props.type + "."}
          onClick={this.openThermocycler}
        >{(!this.props.open)?"Open":"Close"}</button>
        {(this.props.open && this.props.numberOfSolutions > 0)?(
          <button
            aria-label={"Eject all thermocycler tubes."}
            onClick={this.ejectAllSolutions}
          >
            <img alt="" src={EjectIcon}/>
          </button>
        ):null}
      </div>
    )
  }

  openThermocycler = () => {
    this.props.thermocyclerOpen({
        id: this.props.id,
        open: !this.props.open
    });
  };

  render() {
    return (
      <ul>
          <li
            style={{zIndex: "1"}}
            id={"Thermocycler_" + this.props.id} tabIndex={0}
            className={"dropTarget Thermocycler "+((!this.props.open)?"closed":"open")}
            onClick={this.showControls}
            onKeyDown={ (e)=>{
              if(e.keyCode===13||e.keyCode===32)this.showControls()
            }}
            aria-label={this.props.altText}
          >
              {(!this.props.controlsVisible)?(
                <p aria-hidden="true" className="label">Thermocycler</p>
              ):this.getControls()}
              <Graphics id={this.props.id}/>
          </li>
      </ul>
    );
  }
}

Thermocycler.propTypes = {
  createThermocycler: PropTypes.func,
};

Thermocycler.defaultProps = {};
